<template>
  <div class="oldTreeImgsPage">
    <div class="evaluateBox">
      <div class="imgWrap dis_flex" v-if="listData.length">
        <div
          class="img"
          v-for="(itemImg, imgIndex) in listData"
          :key="'dfff' + itemImg + imgIndex"
          @click="seeImg(listData, imgIndex)"
        >
          <van-image fit="cover" :src="itemImg" />
        </div>
      </div>
    </div>
    <div class="nonePage" v-if="!this.listData[0]">
      <img :src="nonePng" alt />
      <p>{{ $t("common.noDataTip") }}</p>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import nonePng from "@/assets/none.png";
// import { getToken } from "@/utils/common";
import { mapState } from "vuex";
import {
  getDeviceType,
  getTextImgUrl,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "oldTreeImgs",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      nonePng: nonePng,
      userId: "",
      oldTreeId: "",
      objId: "",
      backstagelists: [],
      listData: [],
      imgList: [],
      showImgs: [], // 展示的img
      swiperShow: false,
      swipercliclIndex: 0,
      page: 0,
      pageSize: 100,
      commentCount: 0,
      commentMainShow: false,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      isLoading: false, //是否处于下拉刷新状态
      clientType: "", //手机类型
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.clientType = getDeviceType();
    window.setFile = this.setFiles;
    this.$nextTick(function () {
      this.userId = this.userinfo.uid;
      this.oldTreeId = this.$route.query.commonId;
      if (this.oldTreeId == undefined) {
        this.oldTreeId = this.dataInfo.id;
      }
      this.initPage();
    });
  },
  methods: {
    initPage() {
      let _this = this;

      _this.$api.universal.oldTree
        .oldTreeMsg(_this.oldTreeId)
        .then((res) => {
          if (res.code == "1") {
            if (res.data.imgUrls && res.data.imgUrls[0]) {
              _this.listData = res.data.imgUrls;
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    seeImg(itemUrls, imgIndex) {
      // let magnifyList = [];
      // this.listData.forEach(SelectBigImgs);

      // function SelectBigImgs(item, index) {
      //   magnifyList.push(item.imgUrl);
      // }
      let data = {
        showImgs: itemUrls,
        swipercliclIndex: imgIndex,
        swiperShow: true,
      };
      this.$store.commit("setDataImgs", data);
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.initPage();
      }, 500);
    },

    // //添加图片
    // addImgs() {
    //   let _this = this;
    //   if (_this.clientType == "android") {
    //     window.android.getInfo(102);
    //   } else {
    //     window.webkit.messageHandlers.getImgs.postMessage("1");
    //   }
    // },
    // setFiles(data) {
    //   //App回调添加上传文件
    //   if(this.clientType == "android"){
    //      this.setImgs(data);
    //   }else{
    //     this.setImgs(JSON.parse(data));
    //   }
    // },
    // setImgs(item) {
    //   //上传图片
    //   let _this = this;
    //   let data = {
    //     baseFile: item,
    //     remarks: "",
    //     treeId: this.oldTreeId
    //   };
    //   _this.$api.universal.oldTree
    //     .addGuShuPhotos(data)
    //     .then(res => {
    //       if (res.code == "1") {
    //         console.log(res.data);
    //         _this.$toast("图片上传成功！");
    //         let arr = [];
    //         arr.push(data);
    //         this.listData = this.listData.concat(arr);
    //       } else {
    //         console.log(res.msg);
    //         _this.$toast(res.msg);
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // },
    // setDelete(index, item) {
    //   //删除上传的文件
    //   let _this = this;
    //   let data = {
    //     baseFile: item,
    //     remarks: "",
    //     treeId: this.oldTreeId
    //   };
    //   this.$dialog
    //     .confirm({
    //       title: "提示",
    //       message: "确认删除该图片吗？"
    //     })
    //     .then(() => {
    //       _this.$api.universal.oldTree
    //         .delGuShuPhotos(item.id)
    //         .then(res => {
    //           if (res.code == "1") {
    //             console.log(res.data);
    //             _this.$toast("图片删除成功！");
    //             this.listData.splice(index, 1);
    //           } else {
    //             console.log(res.msg);
    //             _this.$toast(res.msg);
    //           }
    //         })
    //         .catch(err => {
    //           console.log(err);
    //         });
    //     })
    //     .catch(() => {
    //       // on cancel
    //     });
    // }
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  watch: {
    dataInfo: {
      handler: function () {
        let _this = this;
        _this.ordTreeId = _this.dataInfo.id;
        _this.initPage();
      },
      deep: true,
    },
    userinfo: {
      handler: function () {
        let _this = this;
        _this.userId = _this.userinfo.uid;
      },
      deep: true,
    },
  },
};
</script>
<style lang="less"  >
.oldTreeImgsPage {
  width: 100%;
  height: 100%;
  .evaluateBox {
    width: 100%;
    padding: 8px 16px 0;
    margin-bottom: 10px;
    .imgWrap {
      width: 100%;
      flex-wrap: wrap;

      .img {
        width: 33.33%;
        padding-right: 6px;
        padding-bottom: 6px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        .van-image {
          width: 100%;
        }
        img {
          width: 100%;
          max-height: 75px;
          border-radius: 5px;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
        }
      }
    }
  }
  .addImg {
    margin-left: 16px;
    margin-bottom: 20px;
    width: 85px;
    height: 85px;
    box-sizing: border-box;

    padding: 8px 8px;
    dl {
      border: 1px solid #eee;
      width: 100%;
      height: 100%;
      text-align: center;
      dt {
        display: block;
        margin-top: 8px;
        margin-left: 13px;
        width: 38px;
        height: 33px;
        img {
          max-width: 38px;
        }
      }
      dd {
        font-size: 12px;
        color: #4bc08a;
      }
    }
  }
  .nonePage {
    width: 120px;
    height: 150px;

    position: absolute;
    left: 50%;
    margin-left: -60px;
    top: 50%;
    margin-top: -75px;

    img {
      display: block;
      max-width: 100px;
      max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
    }
  }
}
</style>